/**
 * @ngdoc  component
 * @name   inputFileButton
 * @module csm.ui.importForm
 * @param  {string} name  Input field name.
 * @description
 * Wraps and hides `<input type="file">` to provide for styling. Passes
 * `accept` and `multiple` attributes to `<input>` element. Click on this
 * element will open the file selection dialog.
 *
 * Attempts to implement `ng-model` failed. The only way found to retrieve the
 * select file(s) is find the element using `.querySelector("input[type=file]")`
 * and checking the `files` property.
 *
 * The `change` event will fire when a file is selected so if a text field
 * value is bound to the selected file, it will be updated. But `change` is not
 * fired when the same file is selected, again, and not when the enclosing form
 * is reset. However, if the reset triggers a digest cycle, the bound value
 * will be updated.
 *
 * This was built for use with `importForm`. If it is needed elsewhere, more
 * research into how to make `ng-model` work will probably be needed.
 *
 * https://github.com/angular/angular.js/issues/1375#issuecomment-15690425
 *****************************************************************************/
export const inputFileButton = {
  bindings: {
    accept: '@',
    multiple: '@',
    name: '@'
  },
  transclude: true,

  /*-----------------------------------------*/
  /* Copy input attributes to input element. */
  /*-----------------------------------------*/
  template: function ($element, $attrs) {
    var attrs = ['accept', 'multiple']
      .filter(function (a) {
        return !angular.isUndefined($attrs[a]);
      })
      .map((a) => `${a}="{{$ctrl.${a}}}"`)
      .join('\n');

    return `
      <ng-transclude></ng-transclude>
      <input type="file"
             name="{{$ctrl.name}}"
             ${attrs}
             style="display:none" />`;
  },

  controller: function ($attrs, $scope, $element, $timeout) {
    this.$postLink = function () {
      var inputElement = $element.find('input');

      /*-------------------------------------------*/
      /* Pass 'click' to input element. Ignore     */
      /* event when bubbled up from input element. */
      /*-------------------------------------------*/
      $element.bind('click', function (event) {
        if (event.target !== inputElement[0])
          $timeout(function () {
            inputElement.click();
          });
      });

      /*-------------------------------------------------------*/
      /* Fire a digest cycle when the user changes the input   */
      /* so anything bound to the input field will be updated. */
      /*-------------------------------------------------------*/
      inputElement.bind('change', $timeout);
    };
  }
};
